<h5 class="px-1 py-1 border-bottom">{{words[language].accountSettings}}</h5>

<h5>Corporation Information</h5>
<form class="row" [formGroup]="settingsGroup">
    <div class="form-group col-md-3 col-sm-12 my-0">
        <label for="corpName">Corporation Name</label>
        <input class="form-control text-dark" formControlName="name" type="text" id="corpName">
    </div>
    <div class="form-group col-md-3 col-sm-12 my-0">
        <label for="dbaName">Doing-Business-As Name</label>
        <input class="form-control text-dark" type="text" id="dbaName" formControlName="dbaName">
    </div>
    <div class="form-group col-md-3 col-sm-12 my-0">
        <label for="GDN">GDN</label>
        <input class="form-control text-dark" type="text" formControlName="GDN" id="GDN">
    </div>
    <div class="form-group col-md-3 col-sm-12 my-0">
        <label for="corpID">Corporation ID</label>
        <input class="form-control text-dark" type="text" formControlName="corpId" id="corpID">
    </div>
</form>
<h5>Billing Information</h5>
<form class="row mx-0" [formGroup]="billingInformation">
    <!-- Primary Billing Address input -->
    <div class="form-group col-md-4 col-sm-12 my-0">
        <label for="bAdmin">Billing Admin<small>The user responsible for billing.</small></label>
        <select name="bAdmin" id="bAdmin" class="form-control text-dark" formControlName="billingAdmin" (change)="changeBilling()">
            @for (item of dataCorporate.allUsers; track item) {
            <option [value]="item.id">{{item.corporatesUsers[0].contact.firstName}} {{item.corporatesUsers[0].contact.lastName}}</option>
            }
        </select>
    </div>
    <div class="form-group col-md-3 col-sm-12 my-0">
        <label for="firstName">Contact First Name</label>
        <input class="form-control text-dark" type="text" formControlName="contactFirstName" id="firstName">
    </div>
    <div class="form-group col-md-3 col-sm-12 my-0">
        <label for="lastName">Contact Last Name</label>
        <input class="form-control text-dark" type="text" formControlName="contactLastName" id="lastName">
    </div>
    <!-- phone -->
    <div class="form-group col-md-2 col-sm-12 my-0">
        <label for="bPhone">Billing Phone Number</label>
        <input class="form-control text-dark" formControlName="phoneNumber" type="text" id="bPhone">
    </div>
    <!-- email input-->
    <div class="form-group col-md-3 col-sm-12 my-0">
        <label for="email">Billing {{words[language].emailAddress}}</label>
        <input class="form-control text-dark" type="email" id="email" formControlName="email" placeholder="{{words[language].enterEmailAddress}}">
    </div>

    <h5 class="col-12">Primary Billing Address</h5>
    <div class="row mx-0">
        <div class="form-group col-md-3 col-sm-12 my-0">
            <label for="pAddress">Address</label>
            <input class="form-control text-dark" formControlName="address" type="text" id="pAddress">
        </div>
        <div class="form-group col-md-3 col-sm-12 my-0">
            <label for="pAddress2">Address 2</label>
            <input class="form-control text-dark" type="text" formControlName="address2" id="pAddress2">
        </div>
        <div class="form-group col-md-2 col-sm-12 my-0">
            <label for="pZip">Zip</label>
            <input class="form-control text-dark" type="text" formControlName="zipCode" id="pZip">
        </div>
        <div class="form-group col-md-2 col-sm-12 my-0">
            <label for="pCity">City</label>
            <input class="form-control text-dark" type="text" id="pCity" formControlName="city">
        </div>
        <div class="form-group col-md-2 col-sm-12 my-0">
            <label for="pState">State</label>
            <input class="form-control text-dark" type="text" id="pState" formControlName="state">
        </div>
    </div>
</form>

<!-- security -->
@if (!isDisabled) {
<div class="form-group col-sm-12">
    <label for="" class="bg-light p-2 rounded w-100"><span class="uil-unlock mr-2"></span>{{words[language].security}}</label>
</div>
}

<!-- email input-->
@if (!isDisabled) {
<div class="form-group col-md-8 col-sm-12">
    <label for="loginVerification">{{ words[language][ 'loginVerification' ] }}</label>
    <div class="d-flex">
        <!--security input -->
        @if (isDisabled) {
        <input class="form-control text-dark" disabled type="text" id="loginVerification" placeholder="2-Factor Authentication disabled">
        }
        @if (!isDisabled) {
        <input class="form-control text-dark" type="text" id="loginVerification" placeholder="2-Factor Authentication enabled">
        }
        <!-- enable the input-->
        <button class="btn  btn-sm ml-5" id="btnEnabled" (click)="enableSecurity()" [ngClass]="{'btn-primary': isDisabled,'btn-danger':!isDisabled}">
            @if (isDisabled) {
            <span>{{ words[language][ 'enable' ] }}</span>
            }
            @if (!isDisabled) {
            <span>{{ words[language][ 'disable' ] }}</span>
            }
        </button>
    </div>
</div>
}



<!-- method input-->
@if (!isDisabled) {
<label for="" class="w-100 px-2">Method {{isDisabled}}</label>
}
@if (!isDisabled) {
<div class="form-group mb-3 d-flex px-2 align-items-center">
    <!-- input sms -->
    <input type="radio" formControlName="methodControl" value="sms" id="smsrb"> <label class="mb-0 ml-1" for="smsrb">SMS</label>
    <!-- input email -->
    <input type="radio" formControlName="methodControl" value="email" class="ml-2" id="emailrb"> <label class="mb-0 ml-1" for="emailrb">Email</label>
</div>
}
<!-- log in button -->
<div class="form-group col-md-12 col-sm-12 d-flex align-items-end justify-content-end">
    <div class="mr-auto">
        <h6>Account Registered on: 1/1/2022</h6>
        <!-- <button class="btn btn-xs btn-light text-dark" data-target="#requestToDeactivate"
data-toggle="modal">Request to Deactivate Account</button> -->
    </div>
    <button class="btn btn-success mx-1" id="submitSendInformation" (click)="save()" type="submit" [disabled]="loading">
        @if (loading) {
        <img src="../../../assets/images/loading.svg" alt="" height="20" class="mr-2">
        }
        <span>{{words[language].save}}</span>
    </button>
    <button class="btn btn-light mx-1" id="submitSendInformation" type="submit" (click)="getData(user.corporateId)">
        <span>{{words[language].cancel}}</span>
    </button>
</div>

<div class="m-0 p-1">
    <h5>Invoice History</h5>
    <table class="table table-responsive table-center text-dark w-100">
        <thead>
            <th>Invoice Number</th>
            <th>Invoice Date</th>
            <th>Amount Due</th>
            <th>Amount Paid</th>
            <th>Amount Outstanding</th>
            <th>Status</th>
        </thead>
        <tbody>
            <tr>
                <td>10000</td>
                <td>1/1/2022</td>
                <td>$300.00</td>
                <td>$300.00</td>
                <td>$0.00</td>
                <td>Paid</td>
            </tr>
            <tr>
                <td>20000</td>
                <td>2/1/2022</td>
                <td>$300.00</td>
                <td>$0.00</td>
                <td>$300.00</td>
                <td>Past Due</td>
            </tr>
        </tbody>
    </table>
</div>


<!-- ! delete modal -->
<div class="modal fade" id="requestToDeactivate" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <h4 class="text-danger w-100 text-center">Request to Deactivate</h4>
                <div class="col-md-12 col-sm-12 my-0">
                    <label for="deactivateReason">Deactivation Reason</label>
                    <select name="deactivateReason" id="deactivateReason" class="text-dark form-control form-control-sm">
                        <option>Not Using</option>
                        <option>Switched to DealerCenter</option>
                        <option>Switched to Frazer</option>
                        <option>Closing Business</option>
                    </select>
                </div>
                <div class="col-md-12 col-sm-12 my-0">
                    <label for="deactivationExplanation">Deactivation Explanation</label>
                    <textarea class="text-dark form-control form-control-sm" type="text" rows="3" id="deactivationExplanation"></textarea>
                </div>
                <div class="d-flex justify-content-center">
                    <button class="btn btn-danger mt-2">
                        {{words[language][ 'continue' ] }}
                    </button>
                    <button type="button" class="btn btn-secondary mt-2 ml-2" data-dismiss="modal" id="close-delete-modal">{{words[language][ 'cancel' ] }}</button>
                </div>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->